module.exports = __webpack_public_path__ + "static/media/1INCH.0003a2cf.svg";